import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { MessageService, SelectItem } from 'primeng';
import { deepClone } from 'fast-json-patch';
import { RateCardPresetService } from '../../../services/rate-card-presets/rate-card-preset.service';
import { RateCardPresetDTO } from '../../../interfaces/rate-card-presets/rate-card-preset.dto.interface';

@Component({
  selector: 'preset-rate-card-selector',
  templateUrl: './preset-rate-card-selector.component.html',
  styleUrls: ['./preset-rate-card-selector.component.scss'],
})
export class PresetRateCardSelectorComponent implements OnInit {
  constructor(
    private presetService: RateCardPresetService,
    private messageService: MessageService,
  ) {}

  @Output() presetSelected: EventEmitter<any> = new EventEmitter<any>();

  isBusy = true;

  presets: RateCardPresetDTO[];
  presetOptions: SelectItem[];

  selectedPresetId: number;
  selectedPreset: RateCardPresetDTO;
  selectedRateCardData: any;

  ngOnInit() {
    this.loadPresets();
  }

  loadPresets() {
    this.isBusy = true;
    this.presetService.getPresets().then((res) => {
      this.presets = res;
      this.presetOptions = [];

      res.forEach((item) => {
        if (!item.inactiveDate) {
          this.presetOptions.push({ label: item.presetName, value: item.id });
        }
      });

      this.isBusy = false;
    });
  }

  loadSelectedPreset() {
    // load the full data for the selected preset if it is just the shell
    if (this.selectedPreset.servicePricings?.length == 0) {
      this.isBusy = true;
      this.presetService.getPreset(this.selectedPreset.id).then((res) => {
        this.selectedPreset.servicePricings = res.servicePricings;
        console.log('PRESET Loaded: ', this.selectedPreset);

        const ratecards = deepClone(this.selectedPreset.servicePricings);
        this.selectedRateCardData = this.presetService.getRateCardData(ratecards);

        this.isBusy = false;
      });
    } else {
      var servicePricings = deepClone(this.selectedPreset.servicePricings);
      this.selectedRateCardData = this.presetService.getRateCardData(servicePricings);
    }
  }

  onPresetSelected(event: any) {
    //console.log("Preset selected: ", event);
    if (event?.value && event?.value > 0) {
      this.selectedPreset = this.presets.find((x) => x.id == event.value);
      this.loadSelectedPreset();
    }
  }

  applyPreset() {
    // emit event with ratecard data in format expected for agreement UI
    var preset = this.presets.find((x) => x.id == this.selectedPresetId);
    this.presetSelected.emit({
      id: this.selectedPresetId,
      data: this.selectedRateCardData,
      presetName: preset.presetName,
    });
  }
}
